import React, { useCallback } from "react";
import moment from "moment";

import { FiTrash2, FiChevronUp, FiChevronDown } from "react-icons/fi";
import { FaUser, FaClock } from "react-icons/fa";
import { TbSearch } from "react-icons/tb";
import { MdEvent } from "react-icons/md";
import formatCep from "../../../../utils/FormatCep";
import { momentBDays } from "../../../../utils/MomentBDay";
import styles from "./styles.module.scss";
import { addBusinessDaysIgnoreHolidays } from "../../../../utils/calculateBusinessDay";
import { formatOwnCollectStartAndEnd, handleOwnCollectTime } from "../../../../utils/OwnCollectTime";

export function PackageCard({
  shipping,
  onExpand,
  isExpand,
  onDelete,
  widthWindows,
  linkTracking = false,
  expand = true
}) {
  const addressInfoHandled = address => {
    let finalAddress = address?.street;

    if (!!address?.number) {
      finalAddress += `, ${address?.number}`;
    }

    if (!!address?.complement) {
      finalAddress += `, ${address?.complement}`;
    }

    if (!!address?.district) {
      finalAddress += `, ${address?.district}`;
    }

    return finalAddress;
  };

  const clientName = shipping?.user?.userData[1]?.Value?.split(" ", 2).join(
    " "
  );

  const handlePackage = useCallback(s => {
    if (!!s) {
      const isOwnCollect = Boolean(s?.collectTimeStart || s?.collectTimeEnd || s?.collectFrequency)

      if (isOwnCollect) {
        return {
          ...s,
          destination: s?.collectAddress,
          isOwnCollect: true
        }
      }

      return {
        ...s,
        isShipping: true
      }
    }
  }, [])

  const cardPackage = handlePackage(shipping)
  return (
    <>
      <div className={styles.cardWrapper}>
        {widthWindows > 1024 ? (
          <div className={styles.cardHeader}>
            <div className={styles.content}>
              {cardPackage?.name !== null && !!cardPackage?.name && (
                <div className={styles.groupInfo}>
                  <TbSearch color="#409E6A" size={22} />
                  <strong className={styles.titleDescription}>Nome:</strong>
                  {linkTracking ? (
                    <a
                      href={`/detalhes-objeto/${cardPackage.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className={styles.shippingInfo}>
                        <b>{cardPackage?.name}</b>
                      </span>
                    </a>
                  ) : (
                    <span className={`${styles.shippingInfo}${styles.shippingInfoSRO}`}>{cardPackage?.name}</span>
                  )}
                </div>
              )}
              {cardPackage?.sro !== null && !!cardPackage?.sro && (
                <div className={styles.groupInfo}>
                  <TbSearch color="#409E6A" size={22} />
                  <strong className={styles.titleDescription}>Código:</strong>
                  {linkTracking ? (
                    <a
                      href={`/detalhes-objeto/${cardPackage.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className={styles.shippingInfo}>
                        <b>{cardPackage?.sro}</b>
                      </span>
                    </a>
                  ) : (
                    <span className={`${styles.shippingInfo}${styles.shippingInfoSRO}`}>{cardPackage?.sro}</span>
                  )}
                </div>
              )}

              {(cardPackage?.isOwnCollect) && (
                <div className={styles.groupInfo}>
                  <TbSearch color="#409E6A" size={22} />
                  <strong className={styles.titleDescription}>Coleta:</strong>
                  <span className={`${styles.shippingInfo}${styles.shippingInfoSRO}`}>{cardPackage?.id}</span>
                </div>
              )}

              {clientName && (
                <div className={styles.groupInfo}>
                  <div>
                    <FaUser color="#409E6A" size={18} />
                    <strong className={styles.titleDescription}>
                      Cliente:
                    </strong>
                  </div>
                  <span className={styles.shippingInfo}>{clientName}</span>
                </div>
              )}

              {cardPackage?.isOwnCollect && <div className={styles.groupInfo}>
                <div>
                  <FaClock color="#409E6A" size={18} />
                  <strong className={styles.titleDescription}>
                    HORÁRIO:
                  </strong>
                </div>
                <span className={styles.shippingInfo}>
                  {formatOwnCollectStartAndEnd(cardPackage?.collectTimeStart, cardPackage?.collectTimeEnd) || "--"}
                </span>
              </div>}

              {cardPackage?.created_at !== null && !!cardPackage?.created_at && (
                <div className={styles.groupInfo}>
                  <MdEvent color="#409E6A" size={22} />
                  <strong className={styles.titleDescription}>Criação:</strong>
                  <span className={styles.shippingInfo}>
                    {moment(cardPackage?.created_at).format("DD/MM/YYYY")}
                  </span>
                </div>
              )}
            </div>
            <div className={styles.actionButtonsContainer}>
              {expand &&
                (isExpand ? (
                  <div onClick={onExpand}>
                    <FiChevronUp className={styles.iconOpenClose} />
                  </div>
                ) : (
                  <div onClick={onExpand}>
                    <FiChevronDown className={styles.iconOpenClose} />
                  </div>
                ))}
              <div onClick={onDelete}>
                <FiTrash2 className={styles.iconDelete} />
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.cardHeaderMobile}>
            <div className={styles.content}>
              {cardPackage?.sro !== null && !!cardPackage?.sro && (
                <div className={styles.groupInfo}>
                  <strong className={styles.titleDescription}>Código:</strong>
                  <span className={styles.shippingInfo}>{cardPackage?.sro}</span>
                </div>
              )}
              {cardPackage?.isOwnCollect && (
                <div className={styles.groupInfo}>
                  <strong className={styles.titleDescription}>Coleta:</strong>
                  <span className={styles.shippingInfo}>{cardPackage?.id}</span>
                </div>
              )}
              {clientName && (
                <div className={styles.groupInfo}>
                  <strong className={styles.titleDescription}>Cliente:</strong>
                  <span className={styles.shippingInfo}>{clientName}</span>
                </div>
              )}
              {cardPackage.created_at !== null && !!cardPackage.created_at && (
                <div className={styles.groupInfo}>
                  <strong className={styles.titleDescription}>Criação:</strong>
                  <span className={styles.shippingInfo}>
                    {moment(cardPackage?.created_at).format("DD/MM/YYYY")}
                  </span>
                </div>
              )}
            </div>
            <div className={styles.actionButtonsContainer}>
              <div style={{ display: "flex", gap: "8px" }}>
                {expand &&
                  (isExpand ? (
                    <div onClick={onExpand}>
                      <FiChevronUp className={styles.iconOpenClose} />
                    </div>
                  ) : (
                    <div onClick={onExpand}>
                      <FiChevronDown className={styles.iconOpenClose} />
                    </div>
                  ))}
                <div onClick={onDelete}>
                  <FiTrash2 className={styles.iconDelete} />
                </div>
              </div>
            </div>
          </div>
        )}

        <div className={!isExpand ? styles.cardBodyHidden : styles.cardBody}>
          {cardPackage?.origin && (
            <div
              className={
                !isExpand ? styles.cardContentHidden : styles.cardContent
              }
            >
              <h3>REMETENTE</h3>
              <div className={styles.collectInfo}>
                <p className={styles.highlighted}>
                  <span className={styles.highlighted}>Nome:</span>
                  {cardPackage?.origin?.name}
                </p>
                <p>
                  <span className={styles.highlighted}>CEP:</span>
                  {formatCep(cardPackage?.origin?.zip)}
                </p>

                <p>
                  <span className={styles.highlighted}>Endereço:</span>
                  {addressInfoHandled({
                    street: cardPackage?.origin?.street,
                    number: cardPackage?.origin?.number,
                    complement: cardPackage?.origin?.complement,
                    district: cardPackage?.origin?.district
                  })}
                  - {`${cardPackage?.origin?.city}/${cardPackage?.origin?.state}`}
                </p>
              </div>
            </div>
          )}

          {cardPackage?.destination && <div
            className={
              !isExpand ? styles.cardContentHidden : styles.cardContent
            }
          >
            <h3>{cardPackage?.isOwnCollect ? "END. DE COLETA" : "DESTINATÁRIO"}</h3>
            <div className={styles.collectInfo}>
              {cardPackage?.collectTime && <p className={styles.highlighted}>
                <span className={styles.highlighted}>Horário:</span>
                {handleOwnCollectTime(cardPackage?.collectTime)}
              </p>}

              <p className={styles.highlighted}>
                <span className={styles.highlighted}>Nome:</span>
                {cardPackage?.destination?.name}
              </p>
              <p>
                <span className={styles.highlighted}>CEP:</span>
                {formatCep(cardPackage?.destination?.zip)}
              </p>

              <p>
                <span className={styles.highlighted}>Endereço:</span>
                {addressInfoHandled({
                  street: cardPackage?.destination?.street,
                  number: cardPackage?.destination?.number,
                  complement: cardPackage?.destination?.complement,
                  district: cardPackage?.destination?.district
                })}
                -{" "}
                {`${cardPackage?.destination?.city}/${cardPackage?.destination?.state}`}
              </p>
            </div>
          </div>}

          {cardPackage?.isShipping && (
            <div
              className={
                !isExpand ? styles.cardContentHidden : styles.cardContent
              }
            >
              <h3>PACOTE</h3>
              <div className={styles.collectInfo}>
                <p>
                  {cardPackage?.identificationPackage && (
                    <>{cardPackage?.identificationPackage} </>
                  )}
                  <span className={styles.highlighted}>Peso total:</span>
                  {`${String(cardPackage?.weight)?.replace(".", ",")}kg`}
                </p>

                <p>
                  <span className={styles.highlighted}>Envio com seguro:</span>
                  {cardPackage?.insurance ? "Sim" : "Não"}
                </p>
                <p className={styles.highlighted}>
                  <span className={styles.highlighted}>Previsão de entrega:</span>
                  {cardPackage?.previewDate
                    ? momentBDays(cardPackage?.previewDate).format("DD/MM/YYYY")
                    : momentBDays(addBusinessDaysIgnoreHolidays(
                      cardPackage?.correios?.desconto > 0
                        ? Number(cardPackage?.correios?.prazoEntrega) + 2
                        : Number(cardPackage?.correios?.prazoEntrega)
                    ))
                      .format("DD/MM/YYYY")}
                </p>
                <p>
                  <span className={styles.highlighted}>Peso total:</span>
                  {`${String(cardPackage?.weight)?.replace(".", ",")}kg`}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

function cardShippingAreEqual(prevShipping, nextShipping) {
  const shippingHasSameCheckEqual =
    prevShipping.isSelected === nextShipping.isSelected;

  const widthWindowIsEqual =
    prevShipping.widthWindows === nextShipping.widthWindows;

  return shippingHasSameCheckEqual && widthWindowIsEqual;
}
export const PackageCardComponent = React.memo(
  PackageCard,
  cardShippingAreEqual
);
